import React from 'react';

import './MultipleOptionsSelector.css';

// WIP
const MultipleOptionsSelector = () => {
  const temp = 'TBD: Dynamic multiple option selector';

  return (
    <div>
      <h5>{temp}</h5>
    </div>
  );
};

export { MultipleOptionsSelector };
